import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react'
import CustomTablePage2 from './CustomTablePage2';

const PaymentUploadDataTable = ({paymentData}) => {
    console.log('paymentData', paymentData)
    const tableProps = {
        data: paymentData,
        title: {
          membershipId: 'Membership ID',
          fullName: "Full Name",
          paymentDate: "Payment Date",
          amountPaid: "Amount Paid",
        },
        dataKeys: [
          "membershipId",
          "fullName",
          "paymentDate",
          "amountPaid",
        ],
        transformRow: (item) => ({
          membershipId: <div>{item?.membershipId}</div>,
          fullName:<div>{item?.fullName}</div>,
          paymentDate:<div>{item?.paymentDate}</div>,
          amountPaid:<div>{item?.amountPaid}</div>,
          }),
      };
  return (
    <Box py={'30px'} minH={'100vh'} bgColor={'#FFF'}>
      <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={'20px'} px={'20px'} mb={2}>
        <Text fontSize={'18px'} fontWeight={'700'} color={'rgba(209, 26, 42, 0.5)'} >Payment Data</Text>
      </Flex>
      <CustomTablePage2 {...tableProps} />
    </Box>
  )
}

export default PaymentUploadDataTable